// 接口配置文件
let config = {};

config.httpTimeOut = 60000;

// 分页参数
config.paginationParams = {
    pageSizes: [5, 10, 20, 50],
    layout: 'total, sizes, prev, pager, next, jumper',
};

// 首页
config.mainPage = 'deptList';

// 字典配置
config.dbSysConfig = {
    sex:'001',// 性别
    positionStatus:'002',// 在职状态
    marryStatus:'003',// 婚姻状态
    position:'004',// 职位
    politicalStatus:'005',// 政治面貌
    education:'006',// 学历
    repairOrderStatus:'007',// 抢修工单状态
    affectQuantity:'008',// 影响范围
    affectType:'009',// 影响类型
    overDueStatus:'010',// 超期状态
    contractCustStatus:'011',// 联系客户状态
    breakDownType:'012',// 故障分类
    deptType:'013',// 部门类型
    productType:'016',// 工程性质
    cancelReason:'023',// 工程性质
    repairAttr:'025',// 工单属性
    productStatus:'015',// 工单状态
    volLevel:'027',// 电压等级
};

// 正则
config.Reg = {
    mobile: /^((13[0-9])|(14[5,7])|(15[0-3,5-9])|(16[6])|(17[0,1,3,5-8])|(18[0-9])|(19[8,9]))\d{8}$/,
    email: /^[a-zA-Z0-9_.-]+@[A-Za-z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
};

config.corpNo='CO1524100773815';

// 配置模式 h5/app
config.testMode = 'app';

export default config;



// WEBPACK FOOTER //
// ./src/configs/config.js